// extracted by mini-css-extract-plugin
export var scrollIndicator = "ScrollIndicator-module--scroll-indicator--20FZA";